export default __webpack_public_path__ + "static/media/Emerald Barbs of Subtle Striking.62f0b069.jpg";